import React from 'react'
import { useGlobal } from '../../core/GlobalContext'
import Button from '../button'
import Text from '../text'
import * as styles from './GstInvoiceItem.css'

export const GstInvoiceItem = ({ invoice }) => {
  const {
    documentsState: { docUrlMap },
  } = useGlobal()

  const handleInvoiceClick = invoice => {
    if (docUrlMap[invoice?.invoiceDocumentId]?.url) {
      window.open(docUrlMap[invoice?.invoiceDocumentId]?.url, '_blank', 'noopener,noreferrer')
    }
  }

  const AttributeItem = ({ title, val }) => {
    return (
      <div className={styles.attributeItem}>
        <Text size='0.9' color='var(--grey-text-subtitle-color)'>
          {title}
        </Text>
        <Text number size='0.9'>
          {val}
        </Text>
      </div>
    )
  }

  return (
    <Button type='container' className={styles.invoice} handleClick={() => handleInvoiceClick(invoice)}>
      <div className={styles.header}>
        <Text>{invoice?.invoiceNumber}</Text>
        <Text>{invoice?.revenueDate}</Text>
      </div>
      <div className={styles.itemContainer}>
        <AttributeItem title={'Gross Revenue'} val={invoice?.grossRevenue} />
        <AttributeItem title={'Net Revenue'} val={invoice?.netRevenue} />
        <AttributeItem title={'GST Total'} val={invoice?.gstPaid} />
      </div>
      <div className={styles.itemContainer}>
        <AttributeItem title={'SGST'} val={invoice?.sgst} />
        <AttributeItem title={'CGST'} val={invoice?.cgst} />
        <AttributeItem title={'IGST'} val={invoice?.igst} />
      </div>
    </Button>
  )
}
